module.exports = __webpack_public_path__ + "img/quiro.e31e704b.png";